import React from "react";
import { useParams } from "react-router";
import AddLink from "./AddLink";
import ExistingLink from "./ExistingLink";
import { Squirrel } from "../../../components/spinner/Squirrel";
import { loadableCompleteVerifiedRecordsAtom, izProviderConfigsAtom } from "../../../jotai/atoms";
import { useAtom } from "jotai";
import { NotFound } from "../../../components/NotFound";

export default function SmartHealthLink() {
  const { id } = useParams();
  const [allVerifiedRecords] = useAtom(loadableCompleteVerifiedRecordsAtom);
  const [providerConfigs] = useAtom(izProviderConfigsAtom);

  const currRecord = React.useMemo(() => {
    if (allVerifiedRecords.state !== "hasData") {
      return null;
    }
    return allVerifiedRecords.data.find((record) => record.record.uid === id);
  }, [allVerifiedRecords, id]);

  const providerConfig = providerConfigs.find(
    (config) =>
      config.iz_provider.destination_id.toLowerCase() ===
      currRecord?.record?.izProviderKey.toLowerCase()
  );

  if (allVerifiedRecords.state === "loading") {
    return <Squirrel />;
  }

  if (!currRecord?.record.uid || !providerConfig?.features.smart_health_links) {
    return <NotFound />;
  }

  return (
    <div className="p-6">
      {currRecord?.record.shLink ? (
        <ExistingLink
          link={currRecord.record.shLink}
          patient={`${currRecord.record.firstName} ${currRecord.record.lastName}`}
        />
      ) : (
        <AddLink recordId={currRecord!.record.uid} />
      )}
    </div>
  );
}
